import Select from 'components/CustomSelect/styled';
import { components } from 'components/CustomSelect/component';

export default Select;
export { components };
